import type { ActionKind, PatientAction } from "@ferrivia/api-contract";

export { isActive, currentCheckIn, activeActions, type CurrentCheckIn } from "@ferrivia/api-contract";

export function versionChain(action: PatientAction, actions: PatientAction[]): PatientAction[] {
  const byId = new Map(actions.map((a) => [a.id, a]));
  const chain: PatientAction[] = [];
  const seen = new Set<string>();
  let cursor: PatientAction | undefined = action;
  while (cursor && !seen.has(cursor.id)) {
    seen.add(cursor.id);
    chain.push(cursor);
    cursor = cursor.replacesId ? byId.get(cursor.replacesId) : undefined;
  }
  return chain;
}

export function dueLabelKind(kind: ActionKind): "drawBefore" | "checkIn" {
  return kind === "lab" ? "drawBefore" : "checkIn";
}

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

export function toIsoDate(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function checkInDateFromWeeks(today: Date, weeks: number): string {
  const d = new Date(today.getFullYear(), today.getMonth(), today.getDate() + weeks * 7);
  return toIsoDate(d);
}
